import styled from 'styled-components';

import { colorsPalettes, mixins } from '@similarweb/styles';

export const StyledAccessBanner = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;

  background: ${colorsPalettes.sky['100']};
  border-radius: 6px;
  padding: 12px;
`;

export const StyledIconWrapper = styled.div`
  display: flex;
  margin-right: 8px;
  width: 24px;
  height: 24px;

  img {
    max-width: fit-content;
    width: 24px;
    height: 24px;
  }
`;

export const StyledBannerContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledBannerContentTitle = styled.div`
  display: flex;
  ${mixins.setFontVariant('subtitle1', colorsPalettes.indigo['300'])};
  margin-bottom: 4px;
`;

export const StyledBannerContentDescription = styled.div`
  display: flex;
  ${mixins.setFontVariant('body2', colorsPalettes.indigo['300'])};
  margin-bottom: 12px;
`;

export const StyledBannerBtnWrapper = styled.div`
  display: flex;
`;
